<template>
  <div>
    <!--福利优惠券-->
    <div class="welfareListBox" v-if="paperWelfares.length>0">
      <div class="welfareRow" v-for="item in paperWelfares" >
        <div class='welfareListItem'>
          <div class="welPicWrapper">
            <img src="item.listPic" class="welPic">
          </div>
          <div class="welfareListItemInfo">
            <div class="welTitle">
              <span>{item.title}v-for="item in paperWelfares"</span>
            </div>
            <div class='welfareListItemInfo_btm'>
              <div class='attention'>
                {item.attention}
              </div>
              <div class="moreInfo2">
                <div class="companyinfo">
                  <div>
                    <img src="item.logo"  class="logo">
                  </div>
                  <div class='befrom'>
                    <span>{item.name}</span>
                  </div>
                </div>
                <div>
                  <div class='num'>
                    <span>{item.qmVisitCount}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
import {getDateDiff,config} from  '../../common/js/common.js'
export default {
  name:"paperWelfare",
  props:['paperid'],
  data(){
    return{
     paperWelfares:[],
     page:1,
     pageSize:10,
     globalUrl : config.gobalUrl
    }
  },
  methods:{
    login () {

      this.url = "api/getDiscussWelfares.php?page="+this.page+"&pageSize="+this.pageSize+"&paperid="+this.paperid
      console.log(this.url)
      this.$ajax.autoService
          .login(this.url)
          .then((res) => {
            this.paperWelfares = this.paperWelfares.concat(res.data.map(function (item) {
            // item.createtime = getDateDiff(new Date(item.createtime.replace(/-/g, '/')));
            // if (item.picUrls && item.picUrls != '') {
            //   item.pics = item.picUrls.split(',')
            // }
            // item.menuOpen = false
            return item
          }));
          //this.papers = this.papers[0]
          // console.log(this.papers)
          //   this.$nextTick(() => {
          //     this.REQUIRE = true;
          //     this.loading = false;
          //   });
          }, (res) => {
              console.log("error")
              //this.REQUIRE = true;
          })
     },
  }
}

</script>
<style  lang="stylus">
  .welfareListBox
    width:100%
    .welfareRow
      width: 100%
      background: #f5f5f5
      padding: 25px 20px
      box-sizing: border-box
      margin-top: 20px
      border-radius: 15px
      .welfareListItem
        display: flex
        flex-direction: row
        justify-content: space-between
        .welPicWrapper
          flex: 0 0 140px
          .welPic
            width: 140px
            height:140px
            display: block
        .welfareListItemInfo
          display: flex
          flex-direction: column
          width:100%
          height: 140px
          justify-content: space-between
          padding-left: 30px
          box-sizing: border-box
          .welTitle
            width: 400px
            font-size: 24px
            height: 80px
            color: #000
            overflow: hidden
            text-overflow: ellipsis
            display: -webkit-box
            -webkit-line-clamp: 2
            -webkit-box-orient: vertical
            line-height: 40px
            padding-top: 5px
          .attention
            font-size:32px
            color:#f40
            line-height: 40px
          .moreInfo2
            display: flex
            flex-direction: row
            font-size: 25px
            color: #aaa
            justify-content: space-between
            margin-top: 5px
            line-height: 40px
            .companyinfo
              display: flex
              flex-direction: row
              .logo
                width:30px
                height:30px
                vertical-align: middle
                margin: 5px

</style>



// WEBPACK FOOTER //
// src/components/quan/paperWelfare.vue